export const currencyFormat = (currency) => {
  const nf = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return nf.format(currency ?? 0);
};
